jQuery(function($) {
    $( document ).ready(function() {
        getInTouch();
        countryCodes();
        function getInTouch() {
            let popup = document.querySelector('.popup');
            let button = document.querySelector("#get-in-touch");
            let buttonMobile = document.querySelector("#get-in-touch-menu");
            let closePopupIcon = document.querySelector('.popup #close-popup');

            
            button.addEventListener('click' , function() {
                openPopup();
            })
    
            buttonMobile.addEventListener('click' , function() {
                openPopup();
            })
            
            closePopupIcon.addEventListener('click' , function() {
                closePopup();
            })
            popup.addEventListener('click' , function(e) {
               
                if(e.target.classList.contains('popup')) {
                    closePopup();
                }
                
            })

        }
        function openPopup() {
            let popup = document.querySelector('.popup');
            let body =  document.querySelector('body');
            popup.classList.add('open');
            body.classList.add('no-scroll');
        }
        function closePopup() {
            let popup = document.querySelector('.popup');
            let body =  document.querySelector('body');
            popup.classList.remove('open');
            body.classList.remove('no-scroll');
            resetFields();
        }
       
        function resetFields() {
            let form = document.querySelector('.popup .wpcf7-form');
            let name = form.querySelector('#your-name');
            let email = form.querySelector('#your-email');
            let phone = form.querySelector('#your-phone');
            let message = form.querySelector('#your-message');
            name.value = "";
            email.value = "";
            phone.value = "";
            message.value = "";
        }

        function countryCodes() {
            let contactForm = document.querySelector('.popup .wpcf7-form');
            if(contactForm) {
                let countryCodes = contactForm.querySelector('#countryCodes');
                if(countryCodes) {
                    $.ajax({
                        url: urls.baseurl + '/wp-content/themes/thehamlet/countryCodes.json',
                        dataType: 'json', 
                        success: function(datas) {
                            datas.forEach(function(data) {
                                var option = document.createElement("option");
                                option.text = data.dial_code + ' ' + '(' + data.name + ')';
                                option.value = data.dial_code;
                                if(data.name === "Switzerland") {
                                    option.selected = true;
                                }

                                countryCodes.add(option);
                                
                            })
                            
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            console.error('Une erreur s\'est produite lors du chargement du fichier JSON : ' + errorThrown);
                        }
                    });
                }
            }
            
        }
      

        
    });
});